import { render, staticRenderFns } from "./NovaOcorrencia.vue?vue&type=template&id=ce03243c&"
import script from "./NovaOcorrencia.vue?vue&type=script&lang=js&"
export * from "./NovaOcorrencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports